import {
    many,
    attr,
    fk,
    oneToOne,
} from 'redux-orm';
import { OBJECT_TYPE_SECTOR } from '%paysera_seat_selection/js/seatSelection/config/constants';
import singleLabel from '../defaults/singleLabel';
import polygon from '../defaults/polygon';
import BaseModel from './BaseModel';

class Sector extends BaseModel {
    static modelName = 'Sector';

    static fields = {
        ...BaseModel.fields,
        label: attr({ getDefault: () => singleLabel }),
        configuration: oneToOne('Configuration'),
        rows: many('Row'),
        hall: fk('Hall'),
        objectType: attr({ getDefault: () => OBJECT_TYPE_SECTOR }),
        initializedWithSeats: attr({ getDefault: () => false }),
        shell: attr({ getDefault: () => ({ ...polygon }) }),
    };
}

export default Sector;
